import React, { useState } from 'react';
import {
  Table,
  Tag,
  Typography,
  Tooltip,
  Space,
  Button,
  Modal,
  Descriptions,
} from 'antd';
import { FilePdfOutlined, EyeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// Tu JSON base de candidatos, extendido con resultados de entrevista
const candidatos = [
  {
    id: 1,
    nombre: 'Carlos Méndez',
    email: 'carlos.méndez@ejemplo.com',
    telefono: '555-000-1001',
    estatus: 'Entrevistado',
    experiencia: '5 años',
    fechaAplicacion: '18/04/2023',
    escolaridad: 'Licenciatura en Sistemas Computacionales',
    institucion: 'UNAM',
    anioGraduacion: '2018',
    cvURL: 'https://example.com/cv/carlos-mendez.pdf',
    vacanteCodigo: 'PL001',
    vacantePlaza: 'Desarrollador Frontend',
    vacantePuesto: 'Desarrollador Senior',
    vacanteTipoEmpleado: 'Tiempo Completo',
    vacanteOficio: 'TEC-2023-045',
    vacanteMotivo: 'Crecimiento del equipo',
    vacanteEstatus: 'En Reclutamiento',
    vacantePruebas: ['Técnica Frontend', 'Psicométrica General'],
    solicitanteFolio: 'SOL-2023-001',
    solicitanteNombre: 'Juan Pérez Rodríguez',
    solicitantePuesto: 'Gerente de Desarrollo',
    solicitanteAreaCodigo: 'A001',
    solicitanteAreaNombre: 'Tecnología',
    resumenEntrevista: 'Demostró iniciativa y dominio técnico sólido. Buen manejo de situaciones bajo presión.',
    archivoEntrevista: 'https://example.com/entrevistas/carlos-mendez.pdf',
  },
  // Puedes agregar más candidatos aquí
];
const Evaluaciones = () => {
  // Aquí puedes agregar la lógica y el estado necesario para tu componente
  // eslint-disable-next-line no-unused-vars
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewDetails = (record) => {
    setSelectedCandidate(record);
    setIsModalOpen(true);
  };
  const columns = [
    {
      title: 'Candidato',
      dataIndex: 'nombre',
      key: 'nombre',
      render: (text, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>{text}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>{record.email}</Text>
        </Space>
      ),
    },
    {
      title: 'Vacante',
      dataIndex: 'vacantePlaza',
      key: 'vacantePlaza',
    },
    {
      title: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
      render: (estatus) => <Tag color={estatus === 'Entrevistado' ? 'green' : 'blue'}>{estatus}</Tag>,
    },
    {
      title: 'Resumen de Entrevista',
      dataIndex: 'resumenEntrevista',
      key: 'resumenEntrevista',
      render: (resumen) => (resumen ? (
        <Tooltip title={resumen}>
          <Text ellipsis style={{ maxWidth: 300 }}>{resumen}</Text>
        </Tooltip>
      ) : (
        <Text type="secondary">Sin resumen</Text>
      )),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => handleViewDetails(record)}
        >
          Ver detalles
        </Button>
      ),
    },
  ];
  return (
    <div>
      <Table
        rowKey="id"
        dataSource={candidatos}
        columns={columns}
        pagination={{ pageSize: 5 }}
      />
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        title={`Detalle de Evaluación: ${selectedCandidate?.nombre}`}
        width={800}
      >
        {selectedCandidate && (
          <>
            <Title level={5}>💼 Información de la Vacante</Title>
            <Descriptions bordered size="small" column={2} className="mb-4">
              <Descriptions.Item label="Código">{selectedCandidate.vacanteCodigo}</Descriptions.Item>
              <Descriptions.Item label="Plaza">{selectedCandidate.vacantePlaza}</Descriptions.Item>
              <Descriptions.Item label="Puesto">{selectedCandidate.vacantePuesto}</Descriptions.Item>
              <Descriptions.Item label="Tipo de Empleado">{selectedCandidate.vacanteTipoEmpleado}</Descriptions.Item>
              <Descriptions.Item label="Motivo">{selectedCandidate.vacanteMotivo}</Descriptions.Item>
              <Descriptions.Item label="Estatus">{selectedCandidate.vacanteEstatus}</Descriptions.Item>
              <Descriptions.Item label="Oficio">{selectedCandidate.vacanteOficio}</Descriptions.Item>
              <Descriptions.Item label="Pruebas Asignadas">
                {selectedCandidate.vacantePruebas.map((p) => (
                  <Tag key={p}>{p}</Tag>
                ))}
              </Descriptions.Item>
            </Descriptions>

            <Title level={5}>🗣️ Evaluación de Entrevista</Title>
            <Descriptions bordered size="small" column={1}>
              <Descriptions.Item label="Resumen">
                {selectedCandidate.resumenEntrevista || 'Sin información'}
              </Descriptions.Item>
              <Descriptions.Item label="Archivo Adjunto">
                {selectedCandidate.archivoEntrevista ? (
                  <Button
                    type="link"
                    href={selectedCandidate.archivoEntrevista}
                    target="_blank"
                    icon={<FilePdfOutlined />}
                  >
                    Ver PDF
                  </Button>
                ) : (
                  <Text type="secondary">No se adjuntó archivo</Text>
                )}
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Evaluaciones;
